export default __webpack_public_path__ + "static/media/advenio-logo.0afd9954.png";